// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import Vue from 'vue'
import Mint, { Swipe, SwipeItem, InfiniteScroll } from 'mint-ui'
import 'mint-ui/lib/style.css'
import App from './App'
import router from './router'
import store from './store'
// eslint-disable-next-line
import service from '@/utils/request'
import echarts from 'echarts'

//引入rem
import '@/utils/rem'
//引入插件 使用插件
import './plugins'
//引入百度地图
// import BMap from 'BMap'
// 引入真机调试工具
import VConeole from 'vconsole'
// 过滤器
import filters from '@/filter'
// eslint-disable-next-line
import { Scroll, Checker } from 'cube-ui'
Vue.use(Scroll)
Vue.use(Checker)

// eslint-disable-next-line
process.env.NODE_ENV !== 'production' ? vconsole() : ''

function vconsole() {
  // eslint-disable-next-line
  const vConsole = new VConeole()
}

Vue.use(Mint)

Vue.component(Swipe.name, Swipe)
Vue.component(SwipeItem.name, SwipeItem)
Vue.use(InfiniteScroll)

const isDebugMode = process.env.NODE_ENV !== 'production'

Vue.config.debug = isDebugMode
Vue.config.devtools = isDebugMode
Vue.config.productionTip = false

Vue.prototype.$http = service
Vue.prototype.$echarts = echarts
Vue.filter('integer', function (value) {
  return value ? value.split('.')[0]:''
})

Vue.filter('float', function (value) {
  return value ? value.split('.')[1].substring(0,2):''
})

// 全局过滤器统一处理加载
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js